import { MimeType } from 'types/global'

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (!reader.result || reader.result?.toString().length === 0) {
        reject(new Error('File is empty'))
        return
      }

      resolve(reader.result.toString())
    }
    reader.onerror = (error) => reject(error)
  })

export const base64ToThumbnail = (base64Image: string, targetSize: { width: number; height: number }) =>
  new Promise((resolve) => {
    const img = new Image()

    img.onload = function () {
      const width = img.width
      const height = img.height
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const { width: targetWidth, height: targetHeight } = targetSize
      canvas.width = targetWidth
      canvas.height = targetHeight

      ctx?.drawImage(
        img,
        width > height ? (width - height) / 2 : 0,
        height > width ? (height - width) / 2 : 0,
        width > height ? height : width,
        width > height ? height : width,
        0,
        0,
        targetWidth,
        targetHeight,
      )

      resolve(canvas.toDataURL())
    }

    img.src = base64Image
  })

export const getDocType = (mimeType: MimeType) => {
  const mapping: { [key in MimeType]: string } = {
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
    'image/jpeg': 'JPG',
    'application/pdf': 'PDF',
    'image/png': 'PNG',
    'application/vnd.ms-powerpoint': 'PPT',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
  }

  return mapping[mimeType]
}

export const isImage = (mimeType: MimeType) => {
  switch (mimeType) {
    case 'image/jpg':
    case 'image/jpeg':
    case 'image/png':
      return true
    default:
      return false
  }
}

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const trimExtension = (fileName: string) => fileName.replace(/\.[^/.]+$/, '')

export const openFromUrl = (url: string) => {
  const link = document.createElement('a')
  link.href = '#'
  link.onclick = () => {
    window.open(url, '_blank')?.focus()
  }

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadFromUrl = (url: string, filename = '') => {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadBinaryFileFromUrl = async (url?: string, filename = '') => {
  if (url) {
    const blob = await createBlobUrl(url)
    downloadFromUrl(blob, filename)
  }
}

export const createBlobUrl = async (url: string): Promise<string> => {
  const res = await fetch(url)
  const blob = await res.blob()
  const newUrl = URL.createObjectURL(blob)

  return newUrl
}

export const maxFileSizeInMb = (fileSize: number) => (fileSize / (1024 * 1024)).toFixed(0)
